import { Paper, styled } from "@mui/material";

export const ExportFileBody = styled(Paper)(({ theme }) => ({
  width: "100%",
  height: "calc(100vh - 215px)",
  overflow: "hidden",
  marginTop: theme.spacing(2),
}));
